// This file was generated using `pay js:run gql-v1 --type=fragment --name=FinancialAccountBalanceExternalAccount --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {
  Exact,
  OpenapiExternalAccountFinancialAccountBalanceObjectFieldType,
} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment FinancialAccountBalanceExternalAccountFragment on OpenapiExternalAccountFinancialAccountBalance {
    id
    object
  }
`;

export const financialAccountBalanceExternalAccountFragment: FinancialAccountBalanceExternalAccountFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type FinancialAccountBalanceExternalAccountFragmentData = {
  readonly __typename: 'OpenapiExternalAccountFinancialAccountBalance';
  readonly id: string;
  readonly object: OpenapiExternalAccountFinancialAccountBalanceObjectFieldType;
};

export type FinancialAccountBalanceExternalAccountFragmentVariables = Exact<{
  [key: string]: never;
}>;

const financialAccountBalanceExternalAccountFragmentPermissions = {} as const;

doc.permissions = financialAccountBalanceExternalAccountFragmentPermissions;

export type FinancialAccountBalanceExternalAccountFragmentPermissions =
  V1PermissionToken<
    typeof financialAccountBalanceExternalAccountFragmentPermissions
  >;

export type FinancialAccountBalanceExternalAccountFragmentDocument =
  GraphQlDocument<
    FinancialAccountBalanceExternalAccountFragmentData,
    FinancialAccountBalanceExternalAccountFragmentVariables,
    FinancialAccountBalanceExternalAccountFragmentPermissions
  >;
